export var productionConfig = {
    authApiUrl: 'https://auth.move.tomtom.com',
    legolandApiUrl: 'https://api.move.tomtom.com',
    legolandUiUrl: 'https://move.tomtom.com',
};
//# sourceMappingURL=productionConfig.js.map